// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"692a073a","77":"07960936","115":"ba25f6ef","133":"23a95af2","222":"22024047","247":"f4be37d9","280":"47896007","320":"e0992ac7","338":"d0cb3e6f","354":"41b73d43","444":"31bd161e","526":"05bf3205","567":"83225daf","716":"5f4dd971","779":"852d1eab","860":"39f9fc7e"}[chunkId] + ".chunk.js";
};